<ion-row class="payment-dashboard-row">
  <ion-col
    [size]="columnSizes[0]"
    data-cy="account-activity-row-customer-information"
  >
    <div>
      <p data-cy="account-activity-row-customer-name">
        {{ customerMetrics.customerName | titlecase }}
      </p>
      <a
        data-cy="account-activity-row-customer-number"
        (click)="goToAllInvoices()"
      >
        #{{ customerMetrics.customerNumber }}
      </a>
    </div>
  </ion-col>

  <ion-col [size]="columnSizes[1]" data-cy="account-activity-row-credit-status">
    <p>
      <span
        class="credit-status-circle"
        [ngClass]="{
          green: customerMetrics.creditStatus === CreditStatus.active,
          yellow: customerMetrics.creditStatus === CreditStatus.softHold,
          red: customerMetrics.creditStatus === CreditStatus.onHold,
        }"
      ></span>
      {{ customerMetrics.creditStatus }}
    </p>
  </ion-col>

  <ion-col
    *ngIf="isDsmDashboardOn"
    data-cy="account-activity-row-seller"
    [size]="columnSizes[2]"
  >
    <p class="padding-left" *ngIf="customerMetrics.seller">
      <span
        class="seller-pill"
        [ngClass]="{ selected: isPresentingSellers }"
        (mouseenter)="showSellers($event)"
      >
        {{ customerMetrics.seller | translate }}</span
      >
    </p>
  </ion-col>

  <ion-col [size]="columnSizes[3]" data-cy="account-activity-row-open-invoices">
    <p class="padding-left">{{ customerMetrics.openInvoices }}</p>
  </ion-col>

  <ion-col
    [size]="columnSizes[4]"
    data-cy="account-activity-row-unused-credits
    "
  >
    <p class="padding-left">
      {{ customerMetrics.unusedCredits }}
    </p>
  </ion-col>

  <ion-col
    [size]="columnSizes[5]"
    data-cy="account-activity-row-payment-method"
  >
    <p class="padding-left">
      {{ customerMetrics.paymentMethod }}
    </p>
  </ion-col>

  <ion-col
    [size]="columnSizes[6]"
    data-cy="account-activity-row-current-percentage"
  >
    <p class="padding-left">{{ customerMetrics.currentPercentage }}%</p>
  </ion-col>

  <ion-col
    [size]="columnSizes[7]"
    data-cy="account-activity-row-account-balance"
  >
    {{ customerMetrics.accountBalance | currency }}
  </ion-col>

  <ion-col
    [size]="columnSizes[8]"
    data-cy="account-activity-row-current-balance"
  >
    {{ customerMetrics.currentBalance | currency }}
  </ion-col>

  <ion-col
    [size]="columnSizes[9]"
    data-cy="account-activity-row-overdue-balance"
  >
    {{ customerMetrics.overDueBalance | currency }}
  </ion-col>

  <ion-col data-cy="chevron-next" (click)="goToAllInvoices()">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </ion-col>
</ion-row>
